export type DesktopNotificationPermission = NotificationPermission | 'unsupported';

const notificationApi = (): typeof Notification | null =>
	typeof window !== 'undefined' && 'Notification' in window ? window.Notification : null;

export const getDesktopNotificationPermission = (): DesktopNotificationPermission =>
	notificationApi()?.permission ?? 'unsupported';

export async function requestDesktopNotificationPermission(): Promise<DesktopNotificationPermission> {
	const api = notificationApi();
	if (!api) {
		return 'unsupported';
	}
	if (api.permission !== 'default') {
		return api.permission;
	}
	try {
		return await api.requestPermission();
	} catch {
		return 'denied';
	}
}

export interface DesktopNotification {
	title: string;
	body: string;
	tag: string;
	onClick?: () => void;
}

/** False when the OS notification couldn't be shown, which callers treat as "fall back to a toast". */
export function showDesktopNotification({ title, body, tag, onClick }: DesktopNotification): boolean {
	const api = notificationApi();
	if (!api || api.permission !== 'granted') {
		return false;
	}
	try {
		const notification = new api(title, { body, tag });
		if (onClick) {
			notification.onclick = () => {
				window.focus();
				notification.close();
				onClick();
			};
		}
		return true;
	} catch {
		return false;
	}
}
